// ViewAs is now integrated into AuthProvider.
// This file re-exports from useAuth for backwards compatibility.
import { useAuth } from "../hooks/useAuth";

export const ViewAsProvider = ({ children }) => children;

export const useViewAs = () => {
  const auth = useAuth();
  return {
    viewAsRole: auth.viewAsRole,
    setViewAsRole: auth.setViewAsRole,
    exitViewAs: auth.exitViewAs,
    isViewingAs: auth.isViewingAs,
    isRealAdmin: auth.isRealAdmin,
    effectiveRole: auth.effectiveRole,
    ROLES: auth.VIEW_AS_ROLES,
  };
};
